module.exports = __webpack_public_path__ + "static/media/academia_04.43a9572b.jpg";